import * as React from 'react'
import { IActiveTripResponseV2 } from '../../../types'
import UIMessages from '../../../utils/ui-messages'
import UserLogo from '../../icons/ui/UserLogo'
import { mapViewStrategyStages } from '../../MapView'
import TripActivityLog from '../../../containers/trips/TripActivityLog'

export interface ITripIntegrationFailedProps {
  currentTrip: IActiveTripResponseV2
  setCurrentTripStage: (stage: string) => void
}

class TripIntegrationFailed extends React.Component<ITripIntegrationFailedProps> {
  public componentDidMount() {
    this.props.setCurrentTripStage(mapViewStrategyStages.showPolyline)
  }

  public render() {
    const trip = this.props.currentTrip

    if (!trip) {
      return null
    }

    const operatorName = trip.operator ? `${trip.operator.firstName} ${trip.operator.lastName}` : 'No operator assigned'

    return (
      <React.Fragment>
        <div className='px2 py2'>
          <div className='flex '>
            <div className='col-10 pl2'>
              <div className='flex'>
                <div>{operatorName}</div>
              </div>
              <div className='h6 font-grey2'>
                {trip.service.name} {trip.product.name}
              </div>
              {/* <TripActivityLog currentTrip={this.props.currentTrip} /> */}
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default TripIntegrationFailed



// WEBPACK FOOTER //
// ./src/components/trips/trip-detail/TripIntegrationFailed.tsx